import handleQueryResult from "./util/handleQueryResult"
import type { AxiosInstance } from "axios"

export class MedicalHierarchyClient {
	constructor(private axiosClient: AxiosInstance) {}

	public getSpecialitiesByConsultant = (consultantIds: number[]) =>
		handleQueryResult(
			this.axiosClient.post<{ id: string; name: string }[]>(
				`/api/admin/patientcondition/medicalspecialtiesbyconsultant`,
				consultantIds
			)
		)

	public getSpecialitiesByCondition = (conditionKeys: string[]) =>
		handleQueryResult(
			this.axiosClient.post<{ id: string; name: string }[]>(
				`/api/admin/patientcondition/medicalspecialtiesbyconditions`,
				conditionKeys
			)
		)

	public getProblemAreas = (request: {
		selectedMedicalSpecialtyKey: string
		selectedConsultantIds: number[]
	}) =>
		handleQueryResult(
			this.axiosClient.post<{ id: string; name: string }[]>(
				`/api/admin/patientcondition/problemareasbyconsultantandspecialty`,
				request
			)
		)
}
